import React from "react";
import PropTypes from "prop-types";

import { Redirect } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import ThankYou from "./ThankYou";
import Cancelled from "./Cancelled";
import Failed from "./Failed";
import Loader from "./Loader";
import Button from "@material-ui/core/Button";

const styles = (theme) => ({
  root: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    zIndex: 100000,
  },
  checkoutRoot: {
    margin: theme.spacing(2),
    marginTop: 35,
    background: "#fefefe",
  },
  paper: {
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
  },
  loaderRoot: {
    marginTop: 70,
    display: "flex",
    justifyContent: "center",
  },
  rightIcon: {
    marginLeft: theme.spacing(),
  },
  button: {
    margin: 8,
    fontSize: "13pt",
    fontWeight: 500,
  },
  mobileStepperCont: {
    display: "flex",
    justifyContent: "center",
  },
  stepperMobile: {
    paddingLeft: 17,
  },
  "@media (min-width: 1024px)": {
    stepperMobile: {
      paddingLeft: 24,
    },
    checkoutRoot: {
      marginTop: 90,
      width: 900,
      marginLeft: "auto",
      marginRight: "auto",
    },
    loaderRoot: {
      width: 900,
    },
    stepperControl: {
      margin: 8,
      marginBottom: 0,
      textAlign: "right",
    },
    stepperRoot: {
      paddingBottom: 8,
    },
    stepRoot: {
      margin: 16,
    },
  },
});

class CheckoutPage extends React.Component {
  componentDidMount() {
    const path = window.location.pathname;

    const params = new URLSearchParams(window.location.search);
    const uniqueID = params.get("uniqueID");
    const personalId = params.get("personalId");
    const cardMask = params.get("cardMask");
    const txId = params.get("txId");
    const authNumber = params.get("authNumber");
    const responseMAC = params.get("responseMAC");

    if (path === "/paymentSuccess") {
      this.props.actions.finalizeOrder({
        personalId,
        cardMask,
        txId,
        authNumber,
        responseMAC,
        uniqueID,
      });
    }

    if (path !== "/paymentSuccess") {
      this.props.actions.setPaymentPageStage(path);
    }
  }

  render() {
    const { classes, catalog } = this.props;
    const { paymentStage, orderId } = catalog;

    let content;

    const steps = [
      {
        name: "/paymentSuccess",
        element: (
          <ThankYou
            orderId={orderId}
            resetCartConditions={this.props.actions.resetCartConditions}
          />
        ),
      },
      {
        name: "/paymentCanceled",
        element: (
          <Cancelled
            resetCartConditions={this.props.actions.resetCartConditions}
          />
        ),
      },
      {
        name: "/paymentFailed",
        element: (
          <Failed
            resetCartConditions={this.props.actions.resetCartConditions}
          />
        ),
      },
    ];

    content = (
      <Paper className={classes.stepperRoot} style={{ paddingTop: 16 }}>
        <Loader />
      </Paper>
    );

    if (paymentStage) {
      content = (
        <Paper className={classes.stepperRoot} style={{ paddingTop: 16 }}>
          {steps[steps.findIndex((o) => o.name === paymentStage)].element}
        </Paper>
      );
    }

    return <div className={classes.checkoutRoot}>{content}</div>;
  }
}

CheckoutPage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  actions: PropTypes.object,
  catalog: PropTypes.object.isRequired,
  match: PropTypes.object,
};

export default withStyles(styles, { withTheme: true })(CheckoutPage);
